<div class="col-sm-12">
  <div class="card">
    <div class="card-body">
      @if (showToolbar) {
        <div class="d-flex justify-content-end gap-2 mb-2">
          <button
            class="btn btn-outline-secondary"
            type="button"
            placement="top"
            [ngbTooltip]="'words.reloadTable' | translate"
            (click)="reloadDatatable()">
            <i class="fa fa-repeat"></i>
          </button>
          @if (userType !== USER_TYPE.ALL) {
            @if (
              this.profile.roleId.name !== USER_TYPE.AGENT &&
              this.profile.roleId.name !== USER_TYPE.AFFILIATE
            ) {
              <!-- <button
          class="btn btn-outline-success"
          type="button"
          placement="top"
          [ngbTooltip]="'words.exportExcel' | translate"
          [disabled]="exportLoading"
          (click)="exportCenterExcel()"
        >
          <i class="fa fa-file-excel"></i>
          <span *ngIf="!exportLoading">Excel para Center</span>
          <span
            *ngIf="exportLoading"
            class="spinner-border spinner-border-sm"
          ></span>
        </button> -->
              <shared-dropdown-report-export
                *appShowWithPermission="PERMITTED_VIEWS.EXPORT_EXCEL_SORTI"
                [module]="transactionSorticenter"
                [currentFilters]="currentFilters"
                [currentLimit]="currentLimit"
                [currentPage]="currentPage"
                [buttonText]="'words.exportExcelSorti' | translate"
                (exportRequested)="onReportExportRequested($event)">
              </shared-dropdown-report-export>
            }

            <!-- <button
          class="btn btn-outline-success"
          type="button"
          placement="top"
          [ngbTooltip]="'words.exportExcel' | translate"
          [disabled]="exportLoading"
          (click)="exportToExcel()"
        >
          <i class="fa fa-file-excel"></i>
          <span *ngIf="!exportLoading">Excel</span>
          <span
            *ngIf="exportLoading"
            class="spinner-border spinner-border-sm"
          ></span>
        </button> -->

            <shared-dropdown-report-export
              *appShowWithPermission="PERMITTED_VIEWS.EXPORT_EXCEL_TRANSACTION_REPORTS"
              [module]="transactionBackoffice"
              [currentFilters]="currentFilters"
              [currentLimit]="currentLimit"
              [currentPage]="currentPage"
              (exportRequested)="onReportExportRequested($event)">
            </shared-dropdown-report-export>
          }
        </div>
      }
      <shared-tables-ngx-datatable
        [config]="config$ | async"
        [data]="data$ | async"
        [widthStorageKey]="columnWidthsKey"
        (onChangeLimit)="onChangeLimit($event)"
        (onChangePage)="onChangePage($event)">
      </shared-tables-ngx-datatable>
    </div>
  </div>
</div>
<ng-template #userTemplate let-row="row">
  <span *ngIf="row.userData?.personalInfo; else nonPlayer">
    {{ row.userData.personalInfo?.username }}
  </span>
  <ng-template #nonPlayer>
    {{ row.userData?.username }}
  </ng-template>
</ng-template>

<ng-template #userWithRoleTemplate let-row="row">
  @if (!row.isTotalRow) {
    @let isPlayer = !!row.userData?.personalInfo;
    <span class="d-inline-flex align-items-center gap-2">
      <span class="sc-flag" [ngClass]="isPlayer ? 'sc-flag-neutral' : 'sc-flag-ok'">
        {{ (isPlayer ? 'financial.holders.player' : 'financial.holders.agent') | translate }}
      </span>
      {{ isPlayer ? row.userData.personalInfo?.username : row.userData?.username }}
    </span>
  }
</ng-template>

<ng-template #stateTransaction let-row="row" let-rowIndex="rowIndex">
  <p
    class="item badge"
    badgeStyler
    [badgeValue]="row.stateTransaction"
    [badgeEnum]="TRASACTION_STATUS"
    [badgeStyles]="TRASACTION_STATUS_BADGE_OPTIONS">
    {{ TRASACTION_STATUS_BADGE_OPTIONS[row.stateTransaction]?.[lang.code.value] || '' }}
  </p>
</ng-template>

<ng-template #type let-row="row" let-rowIndex="rowIndex">
  <p
    class="item badge"
    badgeStyler
    [badgeValue]="row.type"
    [badgeEnum]="MONEY_TYPE"
    [badgeStyles]="MONEY_TYPE_BADGE_OPTIONS">
    {{ MONEY_TYPE_BADGE_OPTIONS[row.type]?.[lang.code.value] || '' }}
  </p>
</ng-template>

<ng-template #operationType let-row="row" let-rowIndex="rowIndex">
  <p
    class="item badge"
    badgeStyler
    [badgeValue]="row.operationType"
    [badgeEnum]="TRANSACTION_TYPE"
    [badgeStyles]="TRANSACTION_TYPE_BADGE_OPTIONS">
    {{ TRANSACTION_TYPE_BADGE_OPTIONS[row.operationType]?.[lang.code.value] || '' }}
  </p>
</ng-template>

<ng-template #originTemplate let-row="row">
  @if (!row.isTotalRow && row.origin) {
    <p class="item badge" [ngClass]="originFlagClass(row.origin)">{{ originLabel(row.origin) }}</p>
  }
</ng-template>

<ng-template #createdAt let-row="row" let-rowIndex="rowIndex">
  <p>{{ row.createdAt | date: FORMAT_FOR_DATES_LONG }}</p>
</ng-template>

<ng-template #updatedAt let-row="row" let-rowIndex="rowIndex">
  <p>{{ row.updatedAt | date: FORMAT_FOR_DATES_LONG }}</p>
</ng-template>

<ng-template #amountTemplate let-row="row">
  {{ row.amount | number: TWO_DECIMALS }} {{ row.currencyId?.code }}
</ng-template>

<ng-template #previousBalanceTemplate let-row="row">
  {{ row.previousBalance | number: TWO_DECIMALS }} {{ row.currencyId?.code }}
</ng-template>

<ng-template #currentBalanceTemplate let-row="row">
  {{ row.currentBalance | number: TWO_DECIMALS }} {{ row.currencyId?.code }}
</ng-template>

<ng-template #amountToneTemplate let-row="row">
  <span [class.text-danger]="row.amount < 0" [class.text-success]="row.amount >= 0">
    {{ row.amount | number: TWO_DECIMALS }}
  </span>
</ng-template>

<ng-template #previousBalanceToneTemplate let-row="row">
  @if (isRejected(row)) {
    <ng-container
      *ngTemplateOutlet="
        unchangedBalance;
        context: { $implicit: row.previousBalance, row: row }
      "></ng-container>
  } @else {
    <span class="text-danger">
      {{ row.previousBalance | number: TWO_DECIMALS }} {{ row.currencyId?.code }}
    </span>
  }
</ng-template>

<ng-template #agentPreviousBalanceTemplate let-row="row">
  @let balance = agentBalance(row, AGENT_BALANCE_MOMENTS.PREVIOUS);
  @if (balance === null) {
    —
  } @else if (isAgentBalanceUnchanged(row)) {
    <ng-container
      *ngTemplateOutlet="
        unchangedBalance;
        context: { $implicit: balance, row: row }
      "></ng-container>
  } @else {
    <span class="text-danger">{{ balance | number: TWO_DECIMALS }} {{ row.currencyId?.code }}</span>
  }
</ng-template>

<ng-template #agentCurrentBalanceTemplate let-row="row">
  @let balance = agentBalance(row, AGENT_BALANCE_MOMENTS.CURRENT);
  @if (balance === null) {
    —
  } @else if (isAgentBalanceUnchanged(row)) {
    <ng-container
      *ngTemplateOutlet="
        unchangedBalance;
        context: { $implicit: balance, row: row }
      "></ng-container>
  } @else {
    <span class="text-success"
      >{{ balance | number: TWO_DECIMALS }} {{ row.currencyId?.code }}</span
    >
  }
</ng-template>

<ng-template #unchangedBalance let-balance let-row="row">
  <span
    class="bank-meta d-inline-flex align-items-center gap-1"
    [ngbTooltip]="unchangedBalanceReason(row) | translate"
    tooltipClass="sc-tooltip"
    placement="top"
    container="body">
    {{ balance | number: TWO_DECIMALS }} {{ row.currencyId?.code }}
    <i class="fa fa-info-circle"></i>
  </span>
</ng-template>

<ng-template #currentBalanceToneTemplate let-row="row">
  @if (isRejected(row)) {
    <ng-container
      *ngTemplateOutlet="
        unchangedBalance;
        context: { $implicit: row.previousBalance, row: row }
      "></ng-container>
  } @else {
    <span class="text-success">
      {{ row.currentBalance | number: TWO_DECIMALS }} {{ row.currencyId?.code }}
    </span>
  }
</ng-template>

<ng-template #previousCreditTemplate let-row="row">
  {{ row.previousCredit | number: TWO_DECIMALS }} {{ row.currencyId?.code }}
</ng-template>

<ng-template #currentCreditTemplate let-row="row">
  {{ row.currentCredit | number: TWO_DECIMALS }} {{ row.currencyId?.code }}
</ng-template>

<ng-template #previousRegisteredBalanceTemplate let-row="row">
  {{ row.previousRegisteredBalance | number: TWO_DECIMALS }}
  {{ row.currencyId?.code }}
</ng-template>

<ng-template #currentRegisteredBalanceTemplate let-row="row">
  {{ row.currentRegisteredBalance | number: TWO_DECIMALS }}
  {{ row.currencyId?.code }}
</ng-template>

<ng-template #previousRegisteredCreditTemplate let-row="row">
  {{ row.previousRegisteredCredit | number: TWO_DECIMALS }}
  {{ row.currencyId?.code }}
</ng-template>

<ng-template #currentRegisteredCreditTemplate let-row="row">
  {{ row.currentRegisteredCredit | number: TWO_DECIMALS }}
  {{ row.currencyId?.code }}
</ng-template>
<ng-template #playerTemplate> {{ USER_TYPE.PLAYER }} </ng-template>
<ng-template #roleTemplate let-row="row">
  @if (!row.isTotalRow) {
    <span *ngIf="row.userData && row.userData?.roleId && userType === USER_TYPE.AGENT">
      {{ row.userData.roleId?.name }}
    </span>
    <span
      *ngIf="
        userType === USER_TYPE.PLAYER || (!row.userData?.roleId && userType === USER_TYPE.ALL)
      ">
      Player
    </span>
    <span *ngIf="row.userData && row.userData?.roleId && userType === USER_TYPE.ALL">
      {{ row.userData.roleId?.name || 'Player' }}
    </span>
  }
</ng-template>
<ng-template #userIdTemplate let-row="row">
  <span
    *ngIf="
      userType === USER_TYPE.PLAYER || (userType === USER_TYPE.ALL && row.userData?.accountInfo)
    ">
    {{ row.userData.accountInfo?.playerId }}
  </span>
  <span
    *ngIf="userType === USER_TYPE.AGENT || (userType === USER_TYPE.ALL && row.userData?.userId)">
    {{ row.userData.userId }}
  </span>
</ng-template>
<ng-template #userIdTemplate let-row="row">
  <span
    *ngIf="
      userType === USER_TYPE.PLAYER || (userType === USER_TYPE.ALL && row.userData?.accountInfo)
    ">
    {{ row.userData.accountInfo?.playerId }}
  </span>
  <span
    *ngIf="userType === USER_TYPE.AGENT || (userType === USER_TYPE.ALL && row.userData?.userId)">
    {{ row.userData.userId }}
  </span>
</ng-template>
<ng-template #commentTemplate let-row="row">
  <span title="{{ row?.comment }}">
    {{ row?.comment?.length > 100 ? (row?.comment | slice: 0 : 100) + '...' : row?.comment }}
  </span>
</ng-template>

<ng-template #belongsToTemplate let-row="row">
  @if (!row.isTotalRow) {
    @if (row?.playerId?.accountInfo?.agentId?.username) {
      <span>{{ row.playerId.accountInfo?.agentId?.username }}</span>
    } @else {
      <span>{{ 'reports.transactions.isAgent' | translate }}</span>
    }
  }
</ng-template>
